import { jwtDecode } from "jwt-decode";

const DecodeToken = (token) => {
  return jwtDecode(token);
}
export default DecodeToken;